import {FieldConfig} from './field.config';
import {ControlUpdater} from './control-updater.type';
import {buildAsyncValidators, buildDefaultValidators} from './default-control-builder';

export const defaultControlUpdater: ControlUpdater = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: FieldConfig<any>,
    control
) => {
    updateCommonFields(currentFieldConfig, updateFieldConfig, control);

    if (isCommonValidatorsChanged(currentFieldConfig, updateFieldConfig)) {
        const updatedFieldConfig = {...currentFieldConfig, ...updateFieldConfig};

        const validators = buildDefaultValidators(updatedFieldConfig);
        control.setValidators(validators);
    }
};

export const updateCommonFields: ControlUpdater = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: FieldConfig<any>,
    control
) => {
    if (updateFieldConfig.hasOwnProperty('disabled') && currentFieldConfig.disabled !== updateFieldConfig.disabled) {
        updateFieldConfig.disabled ? control.disable() : control.enable();
    }

    if (updateFieldConfig.hasOwnProperty('asyncValidators')) {
        const asyncValidators = buildAsyncValidators(updateFieldConfig);

        control.setAsyncValidators(asyncValidators);
    }
};

export const isCommonValidatorsChanged: (currentFieldConfig: FieldConfig<any>, updateFieldConfig: FieldConfig<any>) => boolean =
    (currentFieldConfig: FieldConfig<any>, updateFieldConfig: FieldConfig<any>) => {
        if (updateFieldConfig.hasOwnProperty('required') && currentFieldConfig.required !== updateFieldConfig.required) {
            return true;
        }
        if (updateFieldConfig.hasOwnProperty('validators')) {
            return true;
        }

        return false;
    };
